import { app } from '../../../../app';
import { Controller } from './reseller-company-detail.controller';

app.component('companyResellerCompanyDetail', {
    bindings: {
        account: '<',
        administrators: '<',
        companyDetails: '<',
        companyId: '<',
        appType$:'<',
        appTypes$:'<',
    },
    controller: Controller,
    templateUrl: require('./reseller-company-detail.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/reseller/reseller-company-detail/reseller-company-detail.component.js